// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__mpd7u","left":"StickyBox_left__3v4Jv","right":"StickyBox_right__3Z1oF"};